import { USA } from 'Core/interfaces'

export const defaultOptionsSorting = (options: MainSearchOptions[]): MainSearchOptions[] =>
	options.sort((a, b) => (a.label ? a.label.localeCompare(b.label) : 0))

export const usaFirstOptionsSorting = (options: MainSearchOptions[]): MainSearchOptions[] => {
	const usaOptions = options.filter((option) => option.label.toLowerCase().includes(USA))
	const restOptions = options.filter((option) => !option.label.toLowerCase().includes(USA))

	const sortedUSAOptions = defaultOptionsSorting(usaOptions)
	const sortedRestOptions = defaultOptionsSorting(restOptions)

	return [...sortedUSAOptions, ...sortedRestOptions]
}

export const sortOptionsById = (options: MainSearchOptions[]) =>
	options.sort(
		(a, b) => Number(a.props.value) - Number(b.props.value) || a.label.localeCompare(b.label)
	)
